.container {
  :global(.ant-modal-container) {
    padding: 0;
  }

  :global(.ant-modal-body) {
    padding: 30px;

    .mobile({
      padding: 24px;
    });
  }

  :global(.ant-modal-footer) {
    display: flex;
    padding: 0 30px 24px;
    border-top: none;
    .mobile({
      padding: 24px;
    });
  }
}

.title {
  padding-bottom: 6px;
  margin-bottom: 10px;
  text-align: center;
}

.isImg {
  :global(.ant-modal-body) {
    position: relative;
    padding-top: 125px;
  }
}

.imgContainer {
  position: absolute;
  top: -55px;
  left: calc(50% - 90px);
  display: flex;
  width: 180px;
  height: 180px;
  align-items: flex-start;
  justify-content: center;
  border-radius: 100px;
  background: white;
}
